import _ from 'lodash';
import classNames from 'classnames';
// import classNames from 'classnames';
import React, {PropTypes} from 'react';
import update from 'immutability-helper';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import RichDescription from '../../../components/common/RichDescription';
import * as actions from '../../../actions/regActions';
// import Button from '../../../components/common/Button';
import Fuse from 'fuse.js';
import FontAwesome from 'react-fontawesome';
// import DateTimeFormatter from '../../../components/DateTimeFormatter';
import moment from 'moment-timezone';
import 'moment/locale/nb';
import * as permissions from '../../../permission';
// import DateTimeFormatter from '../../../components/DateTimeFormatter';
// import HeaderImage from '../../../components/common/HeaderImage';
// import RichTextInput from '../../../components/common/RichTextInput';
// import TextInput from '../../../components/common/TextInput';
// import CheckboxInput from '../../../components/common/CheckboxInput';
// import DateTimeInput from '../../../components/common/DateTimeInput';
// import RichTextEditor from 'react-rte';
// import FontAwesome from 'react-fontawesome';
// import * as utils from '../../../components/common/utils';
import toastr from 'toastr';

class AddClubMemebers extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.componentWillMount = this.componentWillMount.bind(this);
    this.componentWillReceiveProps = this.componentWillReceiveProps.bind(this);
    this.newID = this.newID.bind(this);
    this.registerMemberForEvent = this.registerMemberForEvent.bind(this);
    this.unregisterMemberForEvent = this.unregisterMemberForEvent.bind(this);
    this.filterUpdate = this.filterUpdate.bind(this);
    this.fitlerOnStatus = this.fitlerOnStatus.bind(this);
    this.getAttendeesDiff = this.getAttendeesDiff.bind(this);
    this.activeContenders = this.activeContenders.bind(this);
    this.canAddMembers = this.canAddMembers.bind(this);
    this.renderMaxContenders = this.renderMaxContenders.bind(this);
    this.state = {
      regMemberList: props.regMemberList,
      availableMembersFilter: "",
      regMembersFilter: "",
      regStatusFilter: "all",
      regStatusNames: {
        all: 'Alle',
        registered: 'Registrerte',
        not_registered: 'Ikke registrerte',
        changed: 'Endrede',
      }
    };
  }

  componentWillMount() {
    // this.props.router.setRouteLeaveHook(this.props.route, () => {
    //   if (!this.askBeforeExit()) {
    //     return false;
    //   }
    // });
  }

  componentWillReceiveProps(nextProps) {
    if(!_.isEqual(nextProps.regMemberList, this.props.regMemberList)) {
      this.setState({
        regMemberList: nextProps.regMemberList,
      });
    }
    if(!_.isEqual(nextProps.errors, this.props.errors)) {
      this.setState({
        errors: nextProps.errors,
      });
    }
  }

  newID() {
    return '_' + Math.random().toString(36).substr(2, 20);
  }

  registerMemberForEvent(member) {
    if (!this.canAddMembers()) {
      return false;
    }
    let index = _.findIndex(this.props.regMemberList, {member: member.id});
    let regMemberList;
    if (index != -1) {
      regMemberList = update(this.state.regMemberList, {[index]:
        {'_destroy': {$set: false}}
      });
    } else {
      let memberReg = {
        member: member.id,
        _destroy: false,
        member_details: member,
        identifier: this.newID()
      };
      regMemberList = update(this.state.regMemberList, {$push: [memberReg]});
    }
    this.props.updateRegMemberList(regMemberList);
  }

  unregisterMemberForEvent(member) {
    let index = _.findIndex(this.props.regMemberList, {member: member.id});
    let regMemberList = update(this.state.regMemberList, {[index]:
      {'_destroy': {$set: true}}
    });
    this.props.updateRegMemberList(regMemberList);
  }

  filterUpdate(e) {
    this.setState({
      [e.target.name]: e.target.value
    });
  }

  fitlerOnStatus(availableMembers, diff) {
    if (this.state.regStatusFilter == 'registered') {
      availableMembers = _(availableMembers).filter((member) => {
        return _.find(this.props.regMemberList, {member: member.id, _destroy: false});
      }).sortBy(['member_details.first_name', 'member_details.last_name']).value();
    } else if (this.state.regStatusFilter == 'not_registered') {
      availableMembers = _(availableMembers).filter((member) => {
        return !_.find(this.props.regMemberList, {member: member.id, _destroy: false});
      }).sortBy(['member_details.first_name', 'member_details.last_name']).value();
    } else if (this.state.regStatusFilter == 'changed') {
      availableMembers = _.filter(availableMembers, (member) => {
        return !!_.find(diff.allChanged, {member: member.id});
      });
    }
    return availableMembers;
  }

  getAttendeesDiff() {
    let deletedAttendees = [];
    let newAttendees = [];
    _(this.props.detailsDiff.member_registrations).forEach((item) => {
      if (item[1] === 0 && item[2] === 0) {
        deletedAttendees.push(item[0]);
      } else if(typeof item != 'string' && item[1] === undefined && item[2] === undefined){
        newAttendees.push(item[0]);
      }
    });
    return {
      deletedAttendees,
      newAttendees,
      allChanged: [...deletedAttendees, ...newAttendees]
    };
  }

  activeContenders() {
    return _.filter(this.state.regMemberList, {_destroy: false});
  }

  canAddMembers(warning=true) {
    let max_contenders = this.props.eventDetails.max_contenders;
    let isAdmin = permissions.hasPermission(this.props.currentUser,
      ['super_admin', 'event_admin'], this.props.eventDetails, 'write');
    if (isAdmin || !max_contenders || max_contenders > _.size(this.activeContenders())) {
      return true;
    } else if(warning) {
      toastr.warning('Max pr. klubb: ' + max_contenders, 'For mange deltagere.');
      return false;
    }
  }

  renderMaxContenders() {
    let max_contenders = this.props.eventDetails.max_contenders;
    let activeContenders = _.size(this.activeContenders());
    if(max_contenders > 0) {
      return (
        <span className={classNames({
            'text-danger': !this.canAddMembers(false)
          })}>
          &nbsp;
           ({activeContenders + '/' + max_contenders})
        </span>
      );
    }
  }

  render() {
    let diff = this.getAttendeesDiff();
    let availableMembers = this.props.memberList;
    availableMembers = this.fitlerOnStatus(availableMembers, diff);
    // let registeredMembers = _(this.props.regMemberList).filter((member) => {
    //   return !member._destroy;
    // }).sortBy(['member_details.first_name', 'member_details.last_name']).value();
    // availableMembers = _.filter(availableMembers, {'active': true});
    if (this.props.show == false) {
      return null;
    }
    if(this.state.availableMembersFilter) {
      let search = new Fuse((availableMembers),{
        keys: ["first_name", "last_name"]
        });
      availableMembers = search.search(this.state.availableMembersFilter);
    }
    // if(this.state.regMembersFilter) {
    //   let search = new Fuse((registeredMembers),{
    //     keys: ["member_details.first_name", "member_details.last_name"]
    //     });
    //   registeredMembers = search.search(this.state.regMembersFilter);
    // }
    return (
      <div className="team-info-wrapper">
        <div className={'page-header'}>
          <h2>Deltagere</h2>
        </div>
        <div>
          {this.props.eventDetails.contenders_description &&
            <div className="panel panel-default">
              <div className="panel-body">
                <RichDescription description={this.props.eventDetails.contenders_description} />
              </div>
            </div>
          }
          {!_.isEmpty(this.props.detailsDiff) && <div className="panel panel-warning">
            <div className="panel-heading">
              <FontAwesome name="warning" />
              &nbsp;
              Endringer som venter på godkjenning
            </div>
            <div className="panel-body">
              <FontAwesome name="plus-square" className="text-success" />
              {' '}
              Deltagere påmeldt: <strong>{_.size(diff.newAttendees)}</strong>
              <br/>
              <FontAwesome name="minus-square" className="text-danger" />
              {' '}
              Deltagere avmeldt: <strong>{_.size(diff.deletedAttendees)}</strong>
            </div>
          </div>}
          <div className="row">
            <div className="col-sm-12">
              <div className="panel panel-default">
                <div className="panel-heading">
                  <h5 className="panel-title panel-heading-w-btn pull-left">
                    Velg deltagere
                    {this.renderMaxContenders()}
                  </h5>
                  <div className="dropdown pull-right">
                    <button className="btn btn-default dropdown-toggle" type="button" id="dropdownMenu1" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true">
                      <FontAwesome name="filter" />
                      {' ' + this.state.regStatusNames[this.state.regStatusFilter] + ' '}
                      <span className="caret" />
                    </button>
                    <ul className="dropdown-menu" aria-labelledby="dropdownMenu1">
                      <li>
                        <a onClick={() => {
                          this.setState({
                            regStatusFilter: 'all'
                          });}}>Alle</a>
                      </li>
                      <li>
                        <a onClick={() => {
                          this.setState({
                            regStatusFilter: 'registered'
                          });}}>Registrert</a>
                      </li>
                      <li>
                        <a onClick={() => {
                          this.setState({
                            regStatusFilter: 'not_registered'
                          });}}>Ikke registrert</a>
                      </li>
                      {!_.isEmpty(diff.allChanged) && <li>
                        <a onClick={() => {
                          this.setState({
                            regStatusFilter: 'changed'
                          });}}>Endringer</a>
                      </li>}
                    </ul>
                  </div>
                  <div className="clearfix" />
                </div>
                <div className="panel-body member-reg-search">
                  <div className="input-group">
                    <span className="input-group-addon" id="basic-addon3">
                      <FontAwesome
                        name="search" />
                    </span>
                    <input
                      type="search"
                      name="availableMembersFilter"
                      className="form-control"
                      onChange={this.filterUpdate}
                      value={this.state.availableMembersFilter}
                      />
                  </div>
                </div>
                <div className="member-reg-search-divider" />
                <div className="panel-body registration-list">
                  {availableMembers.map((member) => {
                    let registered = _.find(this.state.regMemberList,
                      {member: member.id, _destroy: false});
                    // let arhived = member.archived;
                    let deleted = _.find(diff.deletedAttendees, {member: member.id});
                    let added = _.find(diff.newAttendees, {member: member.id});
                    return (
                      <div key={member.id}
                        className="list-group-item clearfix text-left">
                        {deleted && <span>
                          <FontAwesome name="minus-square" className="text-danger" />
                          &emsp;
                        </span>}
                        {added && <span>
                          <FontAwesome name="plus-square" className="text-success" />
                          &emsp;
                        </span>}
                        <span className="member-name">
                          <strong className={classNames(
                              {'text-muted': member.archived})}>
                            {member.first_name + ' ' + member.last_name}
                          </strong>
                          &emsp;
                          <span className={classNames({'text-muted': member.archived})}>
                            {moment.tz(member.birth_date,
                              'Europe/Oslo').format("DD.MM.YYYY")}
                          </span>
                          {member.archived && <span className="text-muted">
                            &nbsp;
                            (Arkivert medlem)
                          </span>}
                        </span>
                        <button
                          className={classNames('btn btn-sm pull-right',
                            {'disabled btn-disabled': (!registered && member.archived),
                             'btn-primary': (!registered && !member.archived),
                             'btn-danger': registered,})}
                          onClick={(e) => {
                            e.preventDefault();
                            if (registered) {
                              this.unregisterMemberForEvent(member);
                            } else if (!registered && !member.archived) {
                              this.registerMemberForEvent(member);
                            }
                          }}
                          >
                          {!registered ? ('Meld på') : ('Meld av')}
                        </button>
                      </div>
                    );
                  })}
                  {!availableMembers.length && <div className="alert alert-info">
                    {'Ingen flere deltagere'}
                  </div>}
                </div>
              </div>
            </div>
            {/*<div className="col-sm-6">
              <div className="panel panel-default">
                <div className="panel-heading">
                  <h5>Påmeldte deltagere</h5>
                </div>
                <div className="panel-body member-reg-search">
                  <div className="input-group">
                    <span className="input-group-addon" id="basic-addon3">
                      <FontAwesome
                        name="search" />
                    </span>
                    <input
                      type="search"
                      name="regMembersFilter"
                      className="form-control"
                      onChange={this.filterUpdate}
                      value={this.state.regMembersFilter}
                      />
                  </div>
                </div>
                // <div className="member-reg-search-divider" />
                <div className="panel-body registration-list">
                  {registeredMembers.map((memberReg) => {
                    return (
                      <div key={memberReg.member_details.id}
                        className="list-group-item clearfix text-right">
                        <strong className="pull-left">
                          {memberReg.member_details.first_name + ' ' +
                            memberReg.member_details.last_name}
                        </strong>
                        <a className="btn btn-danger btn-sm"
                          onClick={() => {
                            this.unregisterMemberForEvent(memberReg.member_details);
                          }}>
                          Meld av
                        </a>
                      </div>
                    );
                  })}
                  {!registeredMembers.length && <div className="alert alert-info">
                    Ingen medlemmer er påmeldt.
                  </div>}
                </div>
              </div>
            </div>*/}
          </div>
        </div>
      </div>
    );
  }
}

AddClubMemebers.propTypes = {
  actions: PropTypes.object.isRequired,
  // addMember: PropTypes.func.isRequired,
  currentUser: PropTypes.object.isRequired,
  updateRegMemberList: PropTypes.func,
  submitForm: PropTypes.func.isRequired,
  regMemberList: PropTypes.array,
  eventDetails: PropTypes.object.isRequired,
  clubDetails: PropTypes.object.isRequired,
  memberList: PropTypes.array.isRequired,
  eventId: PropTypes.string.isRequired,
  clubId: PropTypes.string.isRequired,
  detailsUpdated: PropTypes.number,
  errors: PropTypes.object,
  detailsDiff: PropTypes.object,
  loading: PropTypes.bool,
  show: PropTypes.bool,
};

function mapStateToProps(state, ownProps) {
  return {
    loading: state.registration.loading,
    errors: state.registration.errors,
    eventDetails: state.events.eventDetails,
    clubDetails: state.clubs.clubDetails,
    currentUser: state.users.currentUser,
    memberList: state.clubs.memberList,
    eventId: ownProps.eventId,
    clubId: ownProps.clubId,
    detailsUpdated: state.registration.detailsUpdated,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(actions, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AddClubMemebers);



/** WEBPACK FOOTER **
 ** ./src/containers/events/register/AddClubMembers.js
 **/